import { render, staticRenderFns } from "./36.vue?vue&type=template&id=5c84d080&scoped=true&"
import script from "./36.vue?vue&type=script&lang=js&"
export * from "./36.vue?vue&type=script&lang=js&"
import style0 from "./36.vue?vue&type=style&index=0&id=5c84d080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84d080",
  null
  
)

export default component.exports